/** Default GST rate for India (e.g. digital services). */
export const DEFAULT_GST_RATE = 0.18

export type ExclusiveGstBreakdown = {
  baseExcludingGst: number
  gstAmount: number
  total: number
  gstRatePercent: number
}

function round2(n: number): number {
  return Math.round(n * 100) / 100
}

/** Compute GST on a base price exclusive of tax. */
export function breakdownFromExclusiveBase(
  baseExclusive: number,
  gstRate: number = DEFAULT_GST_RATE
): ExclusiveGstBreakdown {
  const baseExcludingGst = round2(baseExclusive)
  // GST is billed in whole rupees: 18% of ₹199 is ₹35.82 on paper, ₹36.00 at the gateway, and the
  // total has to be the sum of the two rounded parts (₹235.00) rather than ₹234.82.
  const gstAmount = Math.round(baseExcludingGst * gstRate)
  const total = round2(baseExcludingGst + gstAmount)
  return {
    baseExcludingGst,
    gstAmount,
    total,
    gstRatePercent: Math.round(gstRate * 100),
  }
}

/** @deprecated Use breakdownFromExclusiveBase — prices are now GST-exclusive. */
export function breakdownFromInclusiveTotal(
  totalInclusive: number,
  gstRate: number = DEFAULT_GST_RATE
): ExclusiveGstBreakdown {
  const total = round2(totalInclusive)
  const baseExcludingGst = round2(total / (1 + gstRate))
  const gstAmount = round2(total - baseExcludingGst)
  return {
    baseExcludingGst,
    gstAmount,
    total,
    gstRatePercent: Math.round(gstRate * 100),
  }
}
